import { configureStore, combineReducers } from "@reduxjs/toolkit";
import UserReducer from '../Reducers/UserSlice';
import CourseReducer from '../Reducers/CourseSlice';
import LookUpReducer from '../Reducers/LookUpSlice';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const Config = {
  key: 'e-learning',
  storage,
};

const rootReducer = combineReducers({
  User: UserReducer,
  Course: CourseReducer,
  LookUpGetAll: LookUpReducer,
});

const persistedReducer = persistReducer(Config, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these paths, where non-serializable values exist 
        ignoredActions: ['persist/PERSIST'],
        ignoredPaths: ['register'], // Adjust this path if necessary
      },
    }),
});

export default store;